import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';

import { useConsolidationDetailContext } from "contexts/ConsolidationDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import ConsolidationShipmentList from "./ConsolidationShipmentList";

const ConsolidationDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';

  const { consolidationDetail } = useConsolidationDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    { source: 'Consolidation', sourceRef: consolidationDetail?._id, }, { skip: !consolidationDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'Consolidation', sourceRef: consolidationDetail?._id, }, { skip: !consolidationDetail?._id }
  );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Shipment", value: "shipment", badgeCount: consolidationDetail?.shipmentId?.length },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {consolidationDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="Consolidation" sourceRef={consolidationDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="Consolidation" sourceRef={consolidationDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
          <ConsolidationShipmentList/>
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default ConsolidationDetailTab;